import React from "react";
import BookingGuestSection from "../sections/BookingGuestSection";
import BookingAdditionalInformationSection from "../sections/BookingAdditionalInformationSection";
import BookingTermsSection from "../sections/BookingTermsSection";
import BookingPaymentSection from "../sections/BookingPaymentSection";
import BookingReviewAndBookSection from "../sections/BookingReviewAndBookSection";
import ErrorHelper from "../../Errors/ErrorHelper";

export default class BookingTotalTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      guestSectionMode:
        this.props.guest_information && this.props.guest_information.id
          ? "RETURNING_CUSTOMER"
          : null,
      step: "Guest",
      sections: {
        Guest: {
          expanded: true,
        },
        AdditionalInformation: {
          expanded: false,
        },
        Payment: {
          expanded: false,
        },
        ReviewAndBook: {
          expanded: false,
        },
      },
      terms_visible: false,
      message_terms_visible: false,
      privacy_visible: false,
    };

    if (this.isGuestSectionComplete() && this.props.validPayment) {
      this.state.step = "ReviewAndBook";
      this.state.sections.Guest.expanded = false;
      this.state.sections.Payment.expanded = false;
      this.state.sections.ReviewAndBook.expanded = true;
    } else if (this.isGuestSectionComplete() && !this.props.validPayment) {
      this.state.step = "Payment";
      this.state.sections.Guest.expanded = false;
      this.state.sections.Payment.expanded = true;
      this.state.sections.ReviewAndBook.expanded = false;
    }

    this.isGuestSectionComplete = this.isGuestSectionComplete.bind(this);
    this.onChangeGuestSectionMode = this.onChangeGuestSectionMode.bind(this);
    this.onExpandCollapse = this.onExpandCollapse.bind(this);
    this.onGoto = this.onGoto.bind(this);
    this.onToggleTerms = this.onToggleTerms.bind(this);
    this.onToggleMessageTerms = this.onToggleMessageTerms.bind(this);
    this.onTogglePrivacy = this.onTogglePrivacy.bind(this);
  }

  componentDidMount() {
    var self = this;
    this.scrollToSection();

    $(window).on("resetBookingFlow", () => {
      self.setState({
        step: "Guest",
        sections: {
          Guest: {
            expanded: true,
          },
          AdditionalInformation: {
            expanded: false,
          },
          Payment: {
            expanded: false,
          },
          ReviewAndBook: {
            expanded: false,
          },
        },
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // scroll to section (if changed)
    if (this.state.step != prevState.step) {
      this.scrollToSection();
    }

    // handle terms
    if (this.state.terms_visible && !prevState.terms_visible) {
      this.setState({ scrollTop: $(window).scrollTop() });
      $(window).scrollTop(0);
      $(document.body).css({ overflow: "hidden" });
    } else if (!this.state.terms_visible && prevState.terms_visible) {
      $(window).scrollTop(this.state.scrollTop);
      $(document.body).css({ overflow: "visible" });
    }

    if (
      prevProps.guest_information.id !== undefined &&
      this.props.guest_information.id === undefined
    ) {
      // just signed out
      this.setState({ guestSectionMode: null });
    }

    if (
      prevProps.substep !== this.props.substep &&
      this.props.substep !== this.state.step &&
      this.props.substep === "Payment"
    ) {
      // handle payment errors
      var { state } = this;
      state.step = "Payment";
      state.sections.Guest.expanded = false;
      state.sections.AdditionalInformation.expanded = false;
      state.sections.Payment.expanded = true;
      state.sections.ReviewAndBook.expanded = false;
      this.setState(state);
    }
  }

  render() {
    return (
      <div className="BookingTotal booking-flow-booking-total-step">
        <div className="row">
          <div className="col-md-7 custom-left-div">
            {ErrorHelper.renderErrors(this.props.errors, [])}
            <BookingGuestSection
              {...this.props}
              expanded={this.state.sections.Guest.expanded}
              onExpandCollapse={this.onExpandCollapse}
              onGoto={this.onGoto}
              emailAddressIsValid={this.validEmail(
                this.props.guest_information.email
              )}
              phoneNumberIsValid={this.validPhoneNumber(
                this.props.guest_information.formatted_phone
              )}
              passwordIsValid={this.validPassword(
                this.props.guest_information.password,
                this.props.guest_information.password_confirmation
              )}
              mode={this.state.guestSectionMode}
              isComplete={this.isGuestSectionComplete()}
              onChangeGuestSectionMode={this.onChangeGuestSectionMode}
              onToggleMessageTerms={this.onToggleMessageTerms}
            />
            {this.props.form_fields.length ? (
              <BookingAdditionalInformationSection
                {...this.props}
                expanded={this.state.sections.AdditionalInformation.expanded}
                onExpandCollapse={this.onExpandCollapse}
                onGoto={this.onGoto}
              />
            ) : null}
            <BookingPaymentSection
              {...this.props}
              expanded={this.state.sections.Payment.expanded}
              onExpandCollapse={this.onExpandCollapse}
              onGoto={this.onGoto}
              step={this.props.form_fields.length ? 3 : 2}
            />
            <BookingReviewAndBookSection
              {...this.props}
              expanded={this.state.sections.ReviewAndBook.expanded}
              onExpandCollapse={true}
              onToggleTerms={this.onToggleTerms}
              onTogglePrivacy={this.onTogglePrivacy}
              guestSectionIsComplete={this.isGuestSectionComplete()}
              paymentSectionIsComplete={this.props.validPayment}
              step={this.props.form_fields.length ? 4 : 3}
            />
            {this.renderTerms()}
            {this.renderMessageTerms()}
            {this.renderPrivacy()}
          </div>
          <div className="col-md-5 custom-right-div">
            <BookingTermsSection
              {...this.props}
              expanded={true}
              onExpandCollapse={true}
              paymentSectionIsComplete={this.props.validPayment}
            />
          </div>
        </div>
      </div>
    );
  }

  // renderErrors() {
  //   if (this.props.errors && this.props.errors.length > 0) {
  //     var errors = this.props.errors.map(function (error) {
  //       if (error != I18n.t("one_or_more_rooms_is_no_longer_available")) {
  //         return <li key={error}>{error}</li>;
  //       }
  //     });

  //     return (
  //       <div className="alert alert-danger">
  //         <ul>{errors}</ul>
  //       </div>
  //     );
  //   }
  // }

  renderTerms() {
    if (this.state.terms_visible) {
      return (
        <div className="fullscreen-terms">
          <div className="overlay"></div>
          <a href="#" className="close-button" onClick={this.onToggleTerms}>
            {I18n.t("hide_terms_and_conditions")}
          </a>
          <div ref="fullscreen_terms">
            <div className="terms-container">
              <div
                className="terms-text"
                dangerouslySetInnerHTML={{ __html: this.generateTerms() }}
              ></div>
              <div className="button-wrapper">
                <button
                  type="button"
                  className="btn"
                  onClick={this.onToggleTerms}
                >
                  {I18n.t("close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderMessageTerms() {
    if (this.state.message_terms_visible) {
      return (
        <div className="fullscreen-terms">
          <div className="overlay"></div>
          <a href="#" className="close-button" onClick={this.onToggleMessageTerms}>
            {I18n.t("hide_message_terms")}
          </a>
          <div ref="fullscreen_terms">
            <div className="terms-container">
              <div
                className="terms-text d-inline"
                dangerouslySetInnerHTML={{ __html: this.generateMessageTerms() }}
              ></div>
              &nbsp;
              <span
                class='message-terms-link d-inline'
                onClick={this.onTogglePrivacy}
                dangerouslySetInnerHTML={{
                  __html: I18n.t("visit_privacy"),
                }}
              ></span>
              <div className="button-wrapper">
                <button
                  type="button"
                  className="btn"
                  onClick={this.onToggleMessageTerms}
                >
                  {I18n.t("close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderPrivacy() {
    if (this.state.privacy_visible) {
      return (
        <div className="fullscreen-terms">
          <div className="overlay"></div>
          <a href="#" className="close-button" onClick={this.onTogglePrivacy}>
            {I18n.t("hide_privacy")}
          </a>
          <div ref="fullscreen_terms">
            <div className="terms-container">
              <div
                className="terms-text"
                dangerouslySetInnerHTML={{ __html: this.generatePrivacy() }}
              ></div>
              <div className="button-wrapper">
                <button
                  type="button"
                  className="btn"
                  onClick={this.onTogglePrivacy}
                >
                  {I18n.t("close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  /**
   * Change handlers
   */

  onExpandCollapse(section, e) {
    e.stopPropagation();
    e.preventDefault();

    if (section !== "Guest") {
      this.state.sections["Guest"]["expanded"] = false;
    }
    if (section !== "AdditionalInformation") {
      this.state.sections["AdditionalInformation"]["expanded"] = false;
    }
    if (section !== "Payment") {
      this.state.sections["Payment"]["expanded"] = false;
    }
    if (section !== "ReviewAndBook") {
      this.state.sections["ReviewAndBook"]["expanded"] = false;
    }

    this.state.sections[section].expanded =
      !this.state.sections[section].expanded;
    this.setState({ sections: this.state.sections });
  }

  onChangeGuestSectionMode(mode) {
    this.setState({ guestSectionMode: mode });
  }

  onGoto(step) {
    this.state.sections.Guest.expanded = false;
    this.state.sections.AdditionalInformation.expanded = false;
    this.state.sections.Payment.expanded = false;
    this.state.sections.ReviewAndBook.expanded = false;
    this.state.sections.ReviewAndBook.expanded = false;

    this.state.sections[step].expanded = true;
    this.setState({ sections: this.state.sections, step: step });
  }

  onToggleTerms(e) {
    e.stopPropagation();
    e.preventDefault();

    if (e && e.target && e.target.tagName && e.target.tagName != "SPAN") {
      // ignore clicks on the "terms" text span
      this.setState({ terms_visible: !this.state.terms_visible });
    }
  }

  onToggleMessageTerms(e) {
    e.stopPropagation();
    e.preventDefault();

    if (e && e.target && e.target.tagName && e.target.tagName != "SPAN") {
      // ignore clicks on the "terms" text span
      this.setState({ message_terms_visible: !this.state.message_terms_visible });
    }
  }

  onTogglePrivacy(e) {
    e.stopPropagation();
    e.preventDefault();

    if (e && e.target && e.target.tagName && e.target.tagName != "SPAN") {
      this.setState({ privacy_visible: !this.state.privacy_visible });
    }
  }

  /**
   * Helper functions
   */

  generateTerms() {
    var terms = {};
    var terms_string = "";

    // bundle up all rate billing policy terms
    if (this.props.reservation_segments) {
      for (
        var i = 0, ilen = this.props.reservation_segments.length;
        i < ilen;
        i++
      ) {
        var reservation_segment = this.props.reservation_segments[i];
  
        if (
          reservation_segment &&
          reservation_segment.rate &&
          reservation_segment.rate.billing_policy
        ) {
          if (terms.hasOwnProperty(reservation_segment.rate.billing_policy.id)) {
            terms[
              reservation_segment.rate.billing_policy.id
            ].reservation_segments.push(reservation_segment);
          } else {
            terms[reservation_segment.rate.billing_policy.id] = {
              terms: reservation_segment.rate.billing_policy.terms,
              reservation_segments: [reservation_segment],
            };
          }
        }
      }
  
      for (var t in terms) {
        terms_string =
          terms_string +
          "<h4>" +
          terms[t].reservation_segments
            .map(function (reservation_segment) {
              return (
                reservation_segment.room_type.name +
                " - " +
                reservation_segment.rate.name
              );
            })
            .join(", ") +
          "</h4><hr />" +
          (terms[t].terms ? terms[t].terms : "");
      }
    }
    return terms_string;
  }

  generateMessageTerms() {
    var terms_string = "";

    terms_string = terms_string + "<br /><br />" + I18n.t("message_terms", {property: this.props.property.name, twilio_number: this.props.property.twilio_number})

    return terms_string;
  }

  generatePrivacy() {
    var privacy_string = "";

    privacy_string = privacy_string + "<br /><br />" + I18n.t("booking_privacy_policy")

    return privacy_string;
  }

  isGuestSectionComplete() {
    return this.props.guestSectionValid;
  }

  scrollToSection() {
    var $section_anchor = $("a[name='" + this.state.step + "']");
    $section_anchor && $section_anchor.length
      ? $("html, body").animate(
          { scrollTop: $section_anchor.offset().top },
          "normal"
        )
      : null;
  }

  validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  validPassword(password, password_confirmation) {
    if (
      password &&
      password_confirmation &&
      password.length > 0 &&
      password_confirmation.length > 0 &&
      password === password_confirmation
    ) {
      return true;
    } else {
      return false;
    }
  }

  validPhoneNumber(phone_number) {
    return /^[a-zA-Z0-9+\-().\s]{10,15}$/.test(phone_number);
  }

  validAnswers(answers) {
    var result = false;
    var fields = this.props.additional_customer_fields;
    var field_ids = fields.map((field) => {
      if (field.required === true) {
        return field.id;
      }
    });
    if (answers && answers.length > 0) {
      for (let i = 0; i < answers.length; i++) {
        if (
          field_ids.includes(answers[i].additional_customer_field_id) &&
          answers[i].answer != ""
        ) {
          result = true;
        }
      }
      return result;
    }
  }
}
